import { render, staticRenderFns } from "./guidePage.vue?vue&type=template&id=22040b65&scoped=true&"
import script from "./guidePage.vue?vue&type=script&lang=js&"
export * from "./guidePage.vue?vue&type=script&lang=js&"
import style0 from "./guidePage.vue?vue&type=style&index=0&id=22040b65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22040b65",
  null
  
)

export default component.exports